import { render } from "./ProjectLink.vue?vue&type=template&id=6c4175c8"
import script from "./ProjectLink.vue?vue&type=script&lang=js"
export * from "./ProjectLink.vue?vue&type=script&lang=js"
script.render = render

export default script